import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton, Stack, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { TP_COLORS } from '../../../../constants';
import { getSubjectColor } from '../../../../helper';
import DetailViewCard from '../../../../components/Card/DetailViewCard';
import { whiteButtonStyles } from '../../../../components/Button/styles';

interface PageHeaderProps {
  curriculum: string;
  subject: string;
  grade: string;
  topic: string;
  subTopic: string;
  subjectCode: string;
  style?: React.CSSProperties;
}

const iconProps = {
  style: { verticalAlign: 'middle' },
};

const titleStyles: React.CSSProperties = {
  color: TP_COLORS.white,
  msTextOverflow: 'ellipsis',
};

const PageHeader: React.FC<PageHeaderProps> = ({
  curriculum,
  subject,
  grade,
  topic,
  subTopic,
  subjectCode,
  style = {},
}) => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        padding: '40px 5%',
        background: getSubjectColor(subject),
        ...style,
      }}
    >
      <Stack direction="row" alignItems="center" width="100%">
        <div style={{ width: '40px' }}>
          <IconButton sx={whiteButtonStyles} onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
        </div>
        <div
          style={{
            padding: '0 20px',
            width: 'calc(100% - 200px)',
            maxWidth: 'calc(100% - 200px)',
          }}
        >
          <Typography
            className="ellipsis-text"
            fontSize="20px"
            fontWeight={500}
            style={titleStyles}
          >
            {curriculum}
            &nbsp;
            <ChevronRightIcon {...iconProps} />
            &nbsp;
            {grade}
            &nbsp;
            <ChevronRightIcon {...iconProps} />
            &nbsp;
            {subject}
            &nbsp;
            <ChevronRightIcon {...iconProps} />
            &nbsp;
            {topic}
            &nbsp;
            <ChevronRightIcon {...iconProps} />
            &nbsp;
            {subTopic}
          </Typography>
        </div>
        <div style={{ width: '120px' }}>
          <DetailViewCard
            title={subjectCode}
            titleProps={{
              variant: 'subtitle1',
              fontWeight: 600,
              className: 'ellipsis-text',
              textAlign: 'center',
            }}
            containerProps={{
              style: { marginBottom: 0 },
              sx: {
                padding: '0px 8px',
                backgroundColor: TP_COLORS.white,
                color: TP_COLORS.black,
              },
            }}
          />
        </div>
      </Stack>
    </div>
  );
};

export default PageHeader;
